import { baseApiUrl } from 'config';

export const BASE_URL = baseApiUrl();
export const SIGN_IN_URL = BASE_URL + 'identity/user/signin/';
export const SIGN_UP_URL = BASE_URL + 'identity/user/signup/';
export const PROFILE_URL = BASE_URL + 'profile/profiles/';
export const QUOTE_URL = BASE_URL + 'quote/quotes/';
export const CREDIT_APP_URL = BASE_URL + 'credit_app/credit_apps/';
export const PORTFOLIO_URL = BASE_URL + 'portfolio/portfolios/';
export const PORTFOLIO_CREDIT_URL = BASE_URL + 'portfolio/credit_apps/';
export const PORTFOLIO_LEASE_URL = BASE_URL + 'portfolio/leases/';
export const RESET_PASSWORD_URL = BASE_URL + 'identity/user/reset_password/';
export const FORGOT_PASSWORD_URL = BASE_URL + 'identity/user/forgot_password/';
export const EMAIL_VERIFICATION_URL = BASE_URL + 'identity/email_validations/';
export const RATE_CARD_URL = BASE_URL + 'quote/rate_cards/';



// WEBPACK FOOTER //
// ./src/utils/api/ApiConstants.js